module.exports = __webpack_public_path__ + "static/horizon-logo-f10ec8f3809714e78e074c001f7d659b.png";